import { AccountBalanceOutlined, AccountCircleOutlined, ArrowForward, ChevronRight, Https, HttpsOutlined, Login, Logout, LogoutOutlined, Menu, PermIdentity, PermIdentityOutlined, Search, SettingsOutlined } from '@mui/icons-material'
import { Button, ClickAwayListener, Divider, Drawer, CircularProgress, Grid, Grow, Dialog, DialogActions, DialogContent, IconButton, MenuItem, MenuList, Paper, Popper } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useMediaQuery } from 'react-responsive'
import { useSnackbar } from 'notistack';
import { Formik, Form } from 'formik'
import { Link, useHistory } from 'react-router-dom';
import * as Yup from 'yup';
import { bindActionCreators } from 'redux'
import { resetPasswordRequest } from '../redux/api/system'
import Logo from './common/Logo'
import MenuAccordion from './common/MenuAccordion'
import { signOutUser } from '../redux/actions/userActions'
import TextInput from './common/TextInput'
import { getPrivilegeStatus } from '../util';
import MessageIcon from '@mui/icons-material/Message';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { isFRSCC } from '../util'

const options = [
    { 
        title: "Resource Management", link: "#", id: ['viewDomains', 'viewResources', 'viewResourceGroup' ], 
        subMenus: [
            { title: "Domains", link: "/internal/domains", id: 'viewDomains' },
            { title: "Resource Group", link: "/internal/resourcegroup", id: 'viewResourceGroup' },
            { title: "Resources", link: "/internal/resource", id: 'viewResources' },
        ] 
    },
    { 
        title: "Data Management", link: "#", id: ['viewUpload', 'viewDatasets' ], 
        subMenus: [
            { title: "Manage Dataset", link: "/internal/datasets", id: 'viewDatasets' },
            { title: "Upload Data", link: "/internal/upload", id: 'viewUpload' },
            { title: "Manage Views", link: "/internal/data-views", id: 'viewDatasets' },
        ] 
    },
    { 
        title: "System Administration", link: "#", id: ['SetupSysParams', 'viewAuditLogs', 'viewInstitutions' ], 
        subMenus: [
            { title: "Audit Logs", link: "/internal/audit-logs", id: 'viewAuditLogs' },
            { title: "Institutions", link: "/internal/institutions", id: 'viewInstitutions' },
            { title: "System Parameters", link: "/internal/system-parameters", id: 'SetupSysParams' },
        ] 
    },
    { 
        title: "User Admin", link: "#", id: ['viewRoles', 'viewAdminContacts', 'viewUsers' ], 
        subMenus: [
            { title: "Roles", link: "/internal/roles", id: 'viewRoles' },
            { title: "Users", link: "/internal/users", id: 'viewUsers' },
            { title: "MDA Admin Details", link: "/internal/list-mda-admins", id: 'viewAdminContacts' },
        ] 
    },
];


export const MuiTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#fff',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
  }));

const GetSubMenus = ({ id, handleMenuItemClick }) => {
    return (
        <>
            <MenuList id="split-button-menu" autoFocusItem>
                {options[id]?.subMenus?.map((option, index) => (
                    getPrivilegeStatus(option.id) &&
                    <Link to={option.link}
                        className={`menu-item`}
                        key={index}
                        onClick={() => handleMenuItemClick()}
                    >
                        {option.title}
                    </Link>
                ))}
            </MenuList>
        </>
    )
}

const   TopHeader = ({ usr, sm, signOutUser }) => {
    const [open, setOpen] = useState(false);
    const [openAdmin, setOpenAdmin] = useState(false);
    const anchorRef = React.useRef(null);
    const adminRef = React.useRef(null);
    const { enqueueSnackbar } = useSnackbar();
    const [ resetAlert, setResetAlert ] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState();
    const history = useHistory()
 
    const handleMenuItemClick = (index) => {
        setSelectedIndex(index);
        setOpen(false); 
    };
  
    const handleToggle = () => {
      setOpen((prevOpen) => !prevOpen);
    };

    const handleAdminToggle = () => {
        setOpenAdmin((prevOpen) => !prevOpen);
    };

    const emailResetPassword = async ({ ...values }) => {
        let payload = values;
        payload.password = '';
        try {
            const res = await resetPasswordRequest(payload);
            if(res?.responseCode === "00") {
                enqueueSnackbar('Default Password sent to your email if account exists')
                signOutUser();

            } else {
                enqueueSnackbar('An error occurred', { variant: 'error' })
            }
        }
        catch(err){
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
        finally {
            setResetAlert(false);
        }
    };
  
    const handleClose = (event) => {
      if (anchorRef.current && anchorRef.current.contains(event.target)) {
        return;
      }
  
      setOpen(false);
    };



    const handleAdminClose = (event) => {
        if (adminRef.current && adminRef.current.contains(event.target)) {
          return;
        }
    
        setOpenAdmin(false);
      };

    return (
        <div className="main-header">
            <div className="header-top top-bg d-none d-lg-block">
                <div className="container-fluid">
                    <div className="col-xl-12">
                        <div className="row d-flex justify-content-between align-items-center">
                            {
                                Boolean(usr?.userData?.user_data) &&
                                <Grid container alignItems={'center'}>
                                    <Grid item xs={6}>
                                        <p className='text-white f-14 m-0'>
                                            {/* <span>{<MessageIcon />} Feedback </span> */}
                                            
                                            <span><AccountBalanceOutlined /> {usr?.userData?.user_data?.institutionName}</span>
                                        </p>
                                    </Grid>
                                    <Grid item xs={6} container justifyContent={'flex-end'}>
                                        <p className='text-white f-14 m-0'>
                                            <span onClick={handleToggle} ref={anchorRef}><SettingsOutlined /> Tools</span>
                                            <span className='pipe'>|</span> 
                                            <span onClick={handleAdminToggle} ref={adminRef}>{<PermIdentity />} {usr?.userData?.user_data?.name} </span>
                            
                                        </p>
                                    </Grid>
                                </Grid>                   
                            }
                        </div>
                        <>
                            <Popper
                                sx={{
                                    zIndex: 1,
                                }}
                                open={open}
                                anchorEl={anchorRef.current}
                                role={undefined}
                                transition
                                disablePortal
                            >
                                {({ TransitionProps, placement }) => (
                                <Grow
                                    {...TransitionProps}
                                    style={{
                                    transformOrigin:
                                        placement === 'bottom' ? 'center top' : 'center bottom',
                                    }}
                                >
                                    <Paper>
                                    <ClickAwayListener onClickAway={handleClose}>
                                        <MenuList id="split-button-menu" className='p-05' autoFocusItem>
                                            {/* <p className='p-2 pt-1 pb-1 m-0'>
                                                <b>Name:</b> {usr?.userData?.user_data?.name} <br />
                                                <b>Institution:</b> {usr?.userData?.user_data?.institutionName}
                                            </p>
                                            <Divider /> */}
                                            {options.map((option, index) => (
                                                getPrivilegeStatus(option.id) &&
                                                <MuiTooltip
                                                    key={index}   
                                                    placement="left-start"
                                                    title={<GetSubMenus handleMenuItemClick={handleMenuItemClick} id={index}/>}
                                                >
                                                    <Link to={option.link}
                                                        className={`menu-item ${(selectedIndex == index) ? 'active' : ''}`}
                                                        onClick={() => handleMenuItemClick(index, option?.subMenus?.length > 0)}
                                                    >
                                                        {option.title}
                                                        {
                                                            option?.subMenus?.length > 0 &&
                                                            <ChevronRight />
                                                        }
                                                    </Link>
                                                </MuiTooltip>
                                            ))}
                                        </MenuList>
                                    </ClickAwayListener>
                                    </Paper>
                                </Grow>
                                )}
                            </Popper>
                        </>
                        <>
                            <Popper
                                sx={{
                                    zIndex: 1,
                                }}
                                open={openAdmin}
                                anchorEl={adminRef.current}
                                role={undefined}
                                transition
                                disablePortal
                            >
                                {({ TransitionProps, placement }) => (
                                <Grow
                                    {...TransitionProps}
                                    style={{
                                    transformOrigin:
                                        placement === 'bottom' ? 'center top' : 'center bottom',
                                    }}
                                >
                                    <Paper>
                                    <ClickAwayListener onClickAway={handleAdminClose}>
                                        <MenuList id="split-button-menu" className='p-05' autoFocusItem>
                                            
                                            <MenuItem
                                                onClick={() => setResetAlert(true)}
                                            >
                                                <HttpsOutlined />
                                                Change Password
                                            </MenuItem>
                                            <Divider />
                                            <MenuItem
                                                onClick={() => signOutUser()}
                                                
                                            >
                                                <Logout />
                                                Logout
                                            </MenuItem>
                                        </MenuList>
                                    </ClickAwayListener>
                                    </Paper>
                                </Grow>
                                )}
                            </Popper>
                        </>
                    </div>
                    <Dialog
                        open={Boolean(resetAlert)}
                        keepMounted
                        disableEscapeKeyDown
                    >
                        <DialogContent>
                            
                            <h2 className='mb-0 mt-0'>Email Password Reset</h2>
                            <p className='mt-05'> If user exists, an email will be sent to you with a temporary password.</p>

                            <Formik
                                initialValues={{ userid: '' }}
                                validationSchema={Yup.object().shape({
                                    userid: Yup.string().required('Email Address is required.'),
                                })}
                                onSubmit={emailResetPassword}
                            >
                                {({ isSubmitting, values }) => (
                                    <Form>
                                        <Grid container spacing={3} paddingY={0}>
                                            <Grid item xs={12}>
                                                <TextInput id='userid' required label='Email' value={values.userid} placeholder='Enter Email Address' />
                                            </Grid>
                                        </Grid>
                                        
                                        <DialogActions className='no-padding pb-0 pt-1'>
                                            <Button onClick={() => { setResetAlert(false) }} variant='contained' color='secondary' fullWidth>Cancel</Button>
                                            <Button variant="contained" type='submit' disabled={isSubmitting} fullWidth>
                                                { isSubmitting ? <CircularProgress size={15} color='inherit' /> : 'Reset' }
                                            </Button>
                                        </DialogActions>
                                    </Form>
                                )}
                            </Formik>
                        </DialogContent>
                    </Dialog>
                </div>
            </div>
        </div>
    )
}

const Header = ({ user, signOutUser }) => {
    const [ usr, setUser ] = useState();
    const [ isMember, setIsMember ] = useState(false);
    const [ openMenu, setOpenMenu ] = useState(false)
    const md = useMediaQuery({ query: '(min-width: 1200px)' })
    const sm = useMediaQuery({ query: '(max-width: 750px)' })


    const mainLinks = [
        { name: 'Home', path: '/', member: true},
        { name: 'Resources', path: '/resources', member: true},
        { name: 'FSRCC', path: '/fsrcc', member: isMember},
        { name: 'Publications', path: '/publications', member: true},
        { name: 'Contact Us', path: '/#contact-us', external: true, member: true },
        { name: 'Help', path: '/help', member: true},
    ];

    useEffect(() => {
        setUser(user)
        setIsMember(user?.userData?.user_data?.isFSRCCMember || false)
    }, [user])

    return (
        <header>
            <div className="header-area header-sticky">
                <TopHeader usr={user} signOutUser={signOutUser} sm={sm} />
                <div className="header-bottom pt-2 pb-2 ">
                    <div className="container-fluid">
                        <div className="row align-items-center">
                            <Grid container alignItems={'center'}>
                                <Grid item xs={6} md={3}>
                                    <Logo />
                                </Grid>
                                <Grid item xs={6} md={9} container justifyContent={'flex-end'} alignItems={'center'}>
                                    {
                                        md ?
                                            <div className="main-menu d-lg-block">
                                                <nav>
                                                    <ul id="navigation" className='mb-0'>
                                                        {
                                                            mainLinks.map((link) => (
                                                                <li>
                                                                    {
                                                                        link.external ?
                                                                        <a href={link.path}>{link.name}</a>        
                                                                        :
                                                                        link.member && <Link  to={link.path}>{link.name}</Link>
                                                                    }
                                                                </li>
                                                            ))
                                                        }
                                                        {
                                                            !user.authenticated &&
                                                            <li>    
                                                                <Link to="/login">
                                                                    <Button variant="contained" size='small' startIcon={<Login />}>Login</Button>
                                                                </Link>
                                                            </li>
                                                        }
                                                    </ul>
                                                </nav>
                                            </div>
                                        :
                                        <>
                                        
                                            {
                                                !user.authenticated &&
                                                <Link to="/login">
                                                    <Button variant="contained" startIcon={<Login />}>Login</Button>
                                                </Link>
                                            }

                                            <IconButton onClick={() =>  setOpenMenu(true)} variant="contained" className="ml-2 menu-mobile-btn" size='large'>
                                                <Menu />
                                            </IconButton>
                                        </>
                                    }
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </div>
            </div>
            
            <Drawer open={openMenu} onClose={() => setOpenMenu(false)} anchor='right'>
                <div className='mobile-header'></div>
                <div className='mobile-menu'>
                    {
                        mainLinks.map((link) => (
                            link.external ?
                            <li><a href={link.path}>{link.name}</a></li>    
                            :
                            <li><Link to={link.path}>{link.name}</Link></li>
                        ))
                    }
                    <Divider className='mt-1 mb-1' />
                    
                    {
                        user.authenticated &&
                        (
                            options.map((option, index) => (
                                getPrivilegeStatus(option.id) &&
                                <li key={index}>
                                    <MenuAccordion link={option} user={user} />
                                </li>
                            ))
                        )
                    }
                </div>
            </Drawer>
        </header>
    )
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ signOutUser }, dispatch)
}
export default connect(({ user }) => ({ user }), mapDispatchToProps)(Header)